import { urlConstants } from './URLConstants'

export const limitOptionsConstants = [
  {
    label: '10',
    value: '10',
  },
  {
    label: '20',
    value: '20',
  },
  {
    label: '25',
    value: '25',
  },
  {
    label: '50',
    value: '50',
  },
  {
    label: '100',
    value: '100',
  },
]

export const radioOptions = [
  { label: 'Yes', id: true },
  { label: 'No', id: false },
]

export const Currency = '$'

export const venturemetCom = '@venturemet.com'

export const itemsPerPage = [10, 20, 25, 50, 100]

export const StatusConstants = {
  PROCESSING: 'Processing',
  CLOSED: 'Closed',
  PAID: 'Paid',
  TICKET_TOTAL: 'Ticket Total',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
}

export const supplierListType = {
  ALL_SUPPLIERS: 2,
  UNASSIGNED_SUPPLIERS: 5,
  ASSIGNED_SUPPLIERS: 6,
  PARENT_SUPPLIERS: 3,
  CHILD_SUPPLIERS: 4,
  PARENT_SUPPLIERS_LIST: 1,
  ACCOUNT_TYPE: 1,
  ACCOUNT_MANAGER: 2,
}

export enum statusType {
  ENABLED,
  DISABLED,
}

export enum userStatusId {
  INACTIVE,
  ACTIVE,
  INVITED,
  ACCEPTED,
}
export enum supplierType {
  UNASSIGNED = 'unassigned',
  PARENT = 'parent',
  SUPPLIER = 'supplier',
  CONSUMER = 'consumer',
  OTHERS = 'others',
}

export enum accountType {
  FREIGHT = 'Freight',
}
export enum supplierActionType {
  MARK_AS_PARENT = 'markAsParent',
  MAP_TO_PARENT = 'mapToParent',
  ADD_SUPPLIER = 'addSupplier',
  MARK_AS_UNASSIGNED = 'markAsUnassigned',
  CHANGE_PARENT = 'changeParent',
  REMOVE_PARENT = 'removeParent',
}

export enum TabEventKeys {
  DETAILS = 'details',
  IMAGES = 'images',
  DOCUMENTS = 'documents',
  USER_INFO = 'userInfo',
  SUPPLIER_CONSUMER_MAPPING = 'supplierConsumerMapping',
}

export enum ImageFilterType {
  ALL = 'all',
  TRUCK_SCALE_IMAGES = 'truckScaleImages',
  OTHER = 'other',
  IS_TRUCK_SCALE_IMAGES = '&isTruckScale=1',
  IS_OTHER_IMAGES = '&isTruckScale=2',
}

export enum EportType {
  EXCEL = 'excel',
  CSV = 'csv',
}

export enum EportFileNames {
  SUPPLIER_CONSUMER_LIST_EXPORT = 'Supplier_Consumer_List',
}

export enum EnvironmentType {
  TEST = 'test',
  DEV = 'development',
  PROD = 'production',
}

export enum PageNames {
  LOGIN = 'Login',
  TICKETS = 'Tickets',
  USER_MANAGEMENT = 'User Management',
  CREATE_USER = 'Create User',
  EDIT_USER = 'Edit User',
  MANAGE_SETTINGS = 'Manage Settings',
  SUPPLIER_CONSUMER_MAPPING = 'Supplier Consumer Mapping',
  SUPPLIER_SETTINGS = 'Supplier Settings',
  USER_SETTINGS = 'User Settings',
  TICKET_DETAIL = 'Ticket Detail',
  SUPPORT = 'Support',
  NOT_FOUND = 'Not Found',
}

const {
  LOGIN,
  TICKETS,
  USER_MANAGEMENT,
  EDIT_USER,
  MANAGE_SETTINGS,
  SUPPLIER_CONSUMER_MAPPING,
  TICKET_DETAIL,
  SUPPORT,
  NOT_FOUND,
} = PageNames

export const PageRoutes = {
  '/': LOGIN,
  '/tickets': TICKETS,
  '/user-management': USER_MANAGEMENT,
  '/user-management/create-user': USER_MANAGEMENT,
  '/user-management/edit-user/:id': EDIT_USER,
  '/manage-settings': MANAGE_SETTINGS,
  '/supplier-consumer-mapping': SUPPLIER_CONSUMER_MAPPING,
  '/tickets/:id': TICKET_DETAIL,
  '/support': SUPPORT,
  '/not-found': NOT_FOUND,
}

// Function to resolve dynamic routes
export function resolvePageRoute(path: string): PageNames {
  const { TICKETS, TICKET_DETAILS, USER_MANAGEMENT, MANAGE_SETTINGS, NOT_FOUND } = urlConstants
  const { USER_SETTINGS, SUPPLIER_SETTINGS } = PageNames
  if (path.startsWith(MANAGE_SETTINGS)) {
    const id = path?.split('/')?.[2]
    if (id) {
      const dataObject = JSON.parse(atob(id)) // Decode the base64 string and Parse the JSON data
      return dataObject.isUserSettings ? USER_SETTINGS : SUPPLIER_SETTINGS
    }
  } else if (path.startsWith(TICKETS)) {
    return PageRoutes[TICKET_DETAILS]
  } else if (path.startsWith(USER_MANAGEMENT)) {
    return PageRoutes[USER_MANAGEMENT]
  }
  // Default to not found page if no match
  return PageRoutes[NOT_FOUND]
}

export const infiniteScrollPageLimit = 300
export const supportIsComming = false
export const characterLimit = 500
export const prependUrl = 'https://dummy.com'
export const numberFormatRegexp = new RegExp(/^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)
export const phoneNumberRegexp = /[^0-9\s-+()]/g

export const languageTypes = {
  en: 'en',
}

// Default mock image and docs - will update once API is ready
export const defaultMockImageDocs = {
  defaultImage1: 'https://i.ibb.co/kc61BHz/Ticket-image-1.png',
  defaultImage2: 'https://i.ibb.co/RYrcN6d/Ticket-image-2.png',
  defaultDoc1: 'https://www.africau.edu/images/default/sample.pdf',
} as const
